const doc = [({"da":({"js":({"admin":({"sheet_layout_boxes":({"edit_modal":({"edit_box_icon":({"add_box_to_row":"Tilføj boks til række", "edit_box":"Rediger boks"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;